import { IValidateSessionData } from './types';

const actions = {
  VALIDATE_SESSION_REQUEST: 'VALIDATE_SESSION_REQUEST',
  VALIDATE_SESSION_SUCCESS: 'VALIDATE_SESSION_SUCCESS',
  VALIDATE_SESSION_ERROR: 'VALIDATE_SESSION_ERROR',

  validateSessionRequest: () => ({
    type: actions.VALIDATE_SESSION_REQUEST,
  }),

  validateSessionSuccess: (data: IValidateSessionData) => ({
    type: actions.VALIDATE_SESSION_SUCCESS,
    payload: data,
  }),

  validateSessionError: () => ({
    type: actions.VALIDATE_SESSION_ERROR,
  }),
};

export default actions;
